import React from "react";

// The health worker verifies DNS reachability, not an end-to-end application request.
// Say exactly what we know so the badge earns trust instead of overstating certainty.
export function hasActiveDomain(listing) {
  if (!listing?.healthLastOkAt || listing.healthFailStreak > 0) return false;
  const checkedAt = new Date(listing.healthLastOkAt).getTime();
  return Number.isFinite(checkedAt) && checkedAt > Date.now() - 14 * 24 * 60 * 60 * 1000;
}

export default function DomainStatusBadge({ listing, compact = false }) {
  if (!hasActiveDomain(listing)) return null;
  return (
    <span title="The listing's domain was recently resolved by Limelite" className={`inline-flex items-center gap-1 border border-lime-500/30 bg-lime-500/10 font-medium text-lime-300 ${compact ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-xs"}`}>
      <span aria-hidden="true">●</span> Domain active
    </span>
  );
}
